// src/components/Header.jsx
import React from "react";
import { User, Info, Settings } from "lucide-react";

const MAX_ROUNDS = 3;

/**
 * Header
 * ──────────────────────────────────────────────────────────────────────
 * Props:
 *   - round: current round index (0‐based)
 *
 * Renders:
 *   - A row of small progress bars (one per round)
 *   - The title "FRESCO"
 *   - Three icons (User, Info, Settings) on the right
 */
export default function Header({ round }) {
  return (
    <div className="header">
      {/* Progress bars */}
      <div className="progress-bar-container">
        {[...Array(MAX_ROUNDS)].map((_, idx) => (
          <div
            key={idx}
            className={`progress-bar ${round > idx ? "completed" : ""}`}
            style={{ opacity: round > idx ? 1 : 0.3 }}
          />
        ))}
      </div>

      {/* Title + Icons */}
      <div className="header-title-container">
        <h1 className="header-title">fresco</h1>
        <div className="header-icons">
          <User className="icon" />
          <Info className="icon" />
          <Settings className="icon" />
        </div>
      </div>
    </div>
  );
}
